
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clipmc)"}},[_c('path',{attrs:{"d":"M9.592 14.167H5.425a.417.417 0 00-.416.416v10c0 .23.186.417.416.417h4.167c.23 0 .417-.187.417-.417v-10a.416.416 0 00-.417-.416zM17.075 5h-4.167a.417.417 0 00-.416.417v19.166c0 .23.186.417.416.417h4.167c.23 0 .417-.187.417-.417V5.417A.417.417 0 0017.075 5z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M24.575 9.167h-4.167a.417.417 0 00-.416.416v15c0 .23.186.417.416.417h4.167c.23 0 .417-.187.417-.417v-15a.417.417 0 00-.417-.416z","fill":"#B4BCCF"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clipmc"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(5 5)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    